import i18n from "../config/languageInit";
const token = localStorage.getItem("jwtToken");

const header = {
  Authorization: `Bearer ${token}`,
  common: { "Accept-Language": i18n.language },
};
export default header;
